import { gql } from '@/__generated__';

const UPDATE_MY_USER = gql(`#graphql
  mutation UserProfile_UpdateMyUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        id
        name
        lastnames
        email
        phone
        phoneNumber
        callingCode
        picture
        twoFactorAuth
        status
      }
    }
  }
`);

export default UPDATE_MY_USER;
